export default "__VITE_ASSET__CFQwJbkQ__"